import styled from 'styled-components';
import {
  flexbox,
  alignItems,
  alignSelf,
  justifyContent
} from '../../../../../styles/helpers/flexbox';

export const Footer = styled.div`
  ${alignSelf('flex-end')}

  margin: 1em;
`;

export const AssignedListItemWrapper = styled.div`
  ${flexbox()}
  ${alignItems('center')}
  ${justifyContent('space-between')}

  padding: 4px 8px;
  div {
    width: 15%;
  }

  > :first-child {
    margin: 0;
    width: auto;
  }

  > :nth-child(2) {
    width: 40%;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: -10px;
  }

`;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-assigned/assigned-list-item/assigned-list-item.styled.js